import { RouteType } from "types/RouteType";
import type SupportMailStore from "./SupportMailStore";

const storeOf = (rootStore: unknown) =>
  (rootStore as { supportMailStore?: SupportMailStore }).supportMailStore;

/**
 * Tickets → Unmatched support mail (#2237): the support e-mail HQ could not
 * file on its own, for a person to place on a client, add to a ticket, or
 * discard.
 *
 * Gate: `requiresAuth` only. The API is the boundary — operators, admins and
 * the configured support-desk staff member, whom the web cannot know — and
 * anyone else is told so by the page, from the API's own 403.
 *
 * Registered BEFORE Tickets in ticketsRoutesList, for the reason InquiryQueue
 * precedes ClientDetail: a literal path must never be read as another route's.
 */
const supportMailRoute: RouteType[] = [
  {
    name: "SupportMail",
    path: "/tickets/support-mail",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Unmatched support mail",
        enableRefreshButton: true,
        component: () => import("./SupportMail.Header"),
      },
      body: {
        component: () => import("./SupportMail.Body"),
        grayBackground: true,
      },
    },
    group: "Clients",
    searchAliases: [
      "support e-mail",
      "support email",
      "support mail",
      "unmatched mail",
      "inbound e-mail",
      "triage",
    ],
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      void storeOf(rootStore)?.load();
    },
    onExit: ({ rootStore }) => {
      storeOf(rootStore)?.reset();
    },
  },
];

export default supportMailRoute;
